import React from "react";
import ButtonBlack from "@shared/uiNew/Button/button_black";
import * as styles from "./Steps.module.scss";

import { stepsData, REGISTER_URL } from "@shared/arrays/support";

export function Steps() {
  return (
    <section className={styles.section}>
      <div className={styles.inner}>
        <h2 className={styles.heading}>{stepsData.title}</h2>

        <ol className={styles.list}>
          {stepsData.steps.map((step, i) => (
            <li key={step.title} className={styles.step}>
              <div className={styles.stepContent}>
                <span className={styles.badge}>{i + 1}</span>
                <h3 className={styles.stepTitle}>{step.title}</h3>
                <p className={styles.stepText}>{step.text}</p>

                {step.link && (
                  <a className={styles.link} href={step.link.href}>
                    {step.link.label}
                  </a>
                )}

                {i === stepsData.steps.length - 1 && (
                  <div className={styles.apps}>
                    {stepsData.apps.map((app) => (
                      <a
                        key={app.href}
                        href={app.href}
                        target="_blank"
                        rel="noreferrer noopener"
                      >
                        <img
                          src={app.image}
                          alt={app.alt}
                          width={140}
                          height={42}
                          loading="lazy"
                          decoding="async"
                        />
                      </a>
                    ))}
                  </div>
                )}
              </div>

              <div className={styles.stepMedia}>
                <img
                  src={step.image}
                  alt=""
                  width={520}
                  height={360}
                  loading="lazy"
                  decoding="async"
                />
              </div>
            </li>
          ))}
        </ol>

        <div className={styles.footer}>
          <ButtonBlack
            icon="arrow"
            text={stepsData.cta}
            href={REGISTER_URL}
            type="link"
          />
        </div>
      </div>
    </section>
  );
}

export default Steps;
